<script setup>
import { useMainStore } from '@/stores/main'

const mainStore = useMainStore()

function layerLeft(idx) {
  const stack = mainStore.slideover_history
  const depth = stack.length - 1 - idx // 0 = topmost
  const topEntry = stack[stack.length - 1]
  const topLeft = topEntry.options?.width || 50

  if (depth === 0) {
    return topLeft
  }
  // Underlying layers peek out 3% to the left per depth level
  return topLeft - depth * 3
}

function layerStyle(idx) {
  return {
    left: layerLeft(idx) + '%',
    zIndex: 101 + idx,
  }
}

function isTopmost(idx) {
  return idx === mainStore.slideover_history.length - 1
}
</script>

<template>
  <div v-if="mainStore.slideover_show" id="overlay" @click.self="mainStore.close_slideover">
    <template v-for="(entry, idx) in mainStore.slideover_history" :key="entry.id">
      <!-- Slideover layer -->
      <div
        class="slideover-layer"
        :class="{ 'is-below': !isTopmost(idx) }"
        :style="layerStyle(idx)"
      >
        <!-- Close button tucked behind the panel -->
        <div v-if="isTopmost(idx)" class="close-btn">
          <button type="button" @click.stop="mainStore.pop_slideover()" class="btn-close btn-close-white" aria-label="Close"></button>
        </div>
        <!-- Clickable overlay for underlying layers -->
        <div v-if="!isTopmost(idx)" class="below-overlay" @click="mainStore.pop_to(idx)"></div>
        <div class="slideover-content">
          <component
            :is="entry.component"
            v-bind="entry.properties"
            :key="entry.id"
            @slideover-close="mainStore.close_slideover"
          />
        </div>
      </div>
    </template>
  </div>
</template>

<style scoped>
#overlay {
  background-color: #1318209e;
  position: fixed;
  right: 0;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 100;
}

.slideover-layer {
  display: block;
  background-color: var(--surface-page);
  position: fixed;
  right: 0;
  top: 0;
  bottom: 0;
  border-radius: 10px 0 0 10px;
  box-shadow: 1px 0 6px 6px #0c101561;
  border-left: 1px solid var(--surface-card-hover);
  transition: left 0.25s ease;
}

.close-btn {
  position: absolute;
  top: 40px;
  left: -55px;
  background-color: var(--surface-page);
  padding: 1rem;
  border-radius: 10px 0 0 10px;
  border-left: 1px solid var(--surface-card-hover);
  border-top: 1px solid var(--surface-card-hover);
  border-bottom: 1px solid var(--surface-card-hover);
  z-index: -1;
}

.btn-close:active {
  box-shadow: none;
}

.below-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.15);
  border-radius: 10px 0 0 10px;
  z-index: 1;
  cursor: pointer;
  transition: background 0.2s ease;
}

.below-overlay:hover {
  background: rgba(0, 0, 0, 0.05);
}

.slideover-content {
  display: flex;
  height: 100%;
  width: 100%;
  position: relative;
}
</style>
